import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const updatePassportDetails = createAsyncThunk("updatePassportDetails", async (data, { rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/updatePassportDetails?sessionId=${data.sessionId}&currentTraveller=${data.currentTraveller}`,
        {details: data.details},
        config
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  });

export {updatePassportDetails};